import React from 'react';
import { XCircle } from 'lucide-react';
export function PainSection() {
  const painPoints = ['Sunday night, staring at a blank session plan with practice starting in 18 hours', 'Typing "fun soccer drills for 8 year olds" into YouTube... again', "Running the same passing drill for the third week in a row because you're out of ideas", 'Kids who look bored halfway through practice — and you can see it', 'That sinking feeling when a parent questions your session structure', 'Not being sure if your players are actually developing the right skills for their age', 'Spending more time planning than actually enjoying the sport you love'];
  return <section className="bg-ink py-20 px-4" data-id="element-124">
      <div className="max-w-4xl mx-auto" data-id="element-125">
        <h2 className="font-display text-4xl md:text-5xl text-white text-center mb-12 uppercase" data-id="element-126">
          If You Coach Youth Soccer,{' '}
          <span className="text-red-500" data-id="element-127">You Know Exactly How This Feels.</span>
        </h2>

        <div className="bg-forest/50 border border-white/5 rounded-2xl p-6 md:p-10 mb-12" data-id="element-128">
          <ul className="space-y-6" data-id="element-129">
            {painPoints.map((point, index) => <li key={index} className="flex items-start gap-4" data-id="element-130">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-131" />
                <p className="text-lg text-gray-200 leading-relaxed" data-id="element-132">{point}</p>
              </li>)}
          </ul>
        </div>

        <p className="text-xl md:text-2xl text-center font-bold text-white leading-relaxed max-w-3xl mx-auto" data-id="element-133">
          "You didn't become a soccer coach to spend hours on Google. You became
          one because you love the game — and you want to pass that love on."
        </p>
      </div>
    </section>;
}